import React, { useState, useEffect } from "react";
import { IoExpand } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import { Button } from "antd";
import axios from "axios";
import ViewTestersDetails from "./viewTesterDetails";
const apiUrl = process.env.REACT_APP_API_Teamlead_Testers;

const TestersTable = ({ nav }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [testers, setTesters] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [serialNumber, setSerialNumber] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const filteredTesters = testers.filter((tester) => {
    const fullName = tester.first_name + " " + tester.last_name;
    return (
      fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      tester.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      tester.contact_number.includes(searchQuery) ||
      tester.gender.toLowerCase().includes(searchQuery.toLowerCase()) ||
      tester.team_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });
  useEffect(() => {
    fetchData();
  }, []);

  const storedUser = localStorage.getItem("user");
  const user = JSON.parse(storedUser);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/${user.userId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch testers");
      }
      const data = await response.json();
      setTesters(data.body);
    } catch (error) {
      console.error("Error fetching testers:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = (userId) => {
    setShowDetails(true);
    setSelectedUserId(userId);
  };

  return (
    <div className="bg-gray-200 min-h-screen">
      <div className="container mx-auto">
        {showDetails ? (
          <ViewTestersDetails
            testerId={selectedUserId}
            setShowDetails={setShowDetails}
          />
        ) : (
          <>
            <div className="flex flex-col md:flex-row justify-between items-center pt-10 mb-4 pl-10 pr-10">
              <h2 className="text-2xl font-bold">All Testers</h2>
              <div className="flex items-center mt-4 md:mt-0">
                <div className="form-control relative ml-4">
                  <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search"
                    className="pl-10 input input-bordered w-30 md:w-auto"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>

            <div className="overflow-x-auto ml-10 mr-10 pl-10 pr-10 pb-10 bg-[white]">
              <table className="table-auto w-full">
                <thead>
                  <tr>
                    <th className="px-4 py-2 text-left">Serial No.</th>
                    <th className="px-4 py-2 text-left">Name</th>
                    <th className="px-4 py-2 text-left">Email</th>
                    <th className="px-4 py-2 text-left">Gender</th>
                    <th className="px-4 py-2 text-left">Contact Info</th>

                    <th className="px-4 py-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : filteredTesters.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No Testers found
                      </td>
                    </tr>
                  ) : (
                    filteredTesters.map((tester, index) => (
                      <tr key={tester.id}>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {serialNumber + index}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {tester.first_name + " " + tester.last_name}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {tester.email}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {tester.gender}
                        </td>
                        <td className="border-t border-b  border-[#ADA7A7] px-4 py-2 text-left">
                          {tester.contact_number}
                        </td>

                        <td className="border-t border-b border-[#ADA7A7] px-4 py-2">
                          <div className="flex justify-center items-center space-x-2">
                            <button
                              onClick={() => handleViewClick(tester.id)}
                              className="text-blue-500 hover:text-blue-700"
                            >
                              <IoExpand color="green" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TestersTable;
